// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"styles_iconContainer__2kojr"};